import * as Stores from '../stores'

export function useBenefitEnroll() {
  const benefitEnroll =
    Stores.CardBenefitsApi.endpoints['POST /benefits/:benefitName/enroll'].useMutation()

  return benefitEnroll
}
